import { useRef } from 'react';
import { useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import { Outlet } from 'react-router-dom';
import { loginRequest } from '@utils';

export const ProtectedRoute = () => {
  const { instance, accounts, inProgress } = useMsal();
  const loginTriggered = useRef(false);

  if (inProgress === InteractionStatus.Logout) {
    return (
      <div className="flex items-center justify-center py-20">
        <p className="text-bodyLg text-text-body">Signing you out...</p>
      </div>
    );
  }

  if (inProgress !== InteractionStatus.None) {
    return (
      <div className="flex items-center justify-center py-20">
        <p className="text-bodyLg text-text-body">Loading...</p>
      </div>
    );
  }

  if (accounts.length === 0) {
    if (!loginTriggered.current) {
      loginTriggered.current = true;
      instance.loginRedirect(loginRequest);
    }
    return null;
  }

  return <Outlet />;
};
